import { useState, useEffect, useRef } from "react";
export default function GallerySection() {
  const [visibleItems, setVisibleItems] = useState<boolean[]>(new Array(8).fill(false));
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const headingRef = useRef<HTMLDivElement | null>(null);
  const [headingVisible, setHeadingVisible] = useState(false);
  const images = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/barbacoa-red-2-1-qt44tu27jjzs53556c2dsy7tbtby48kgjoahew2jrc.jpg",
    alt: "barbacoa-red-2",
    label: "Barbacoa"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/chicharron-1-1-qt44twvq423n3x11pva9ifi73yy1rbvnk28xupyd8o.jpg",
    alt: "chicharron-1",
    label: "Chicharron"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/chips-tostadas-1-1-qt44tzp8ok7i2qwy9ei57wskw4k5ef6ukg7eaju6q0.jpg",
    alt: "chips-tostadas-1",
    label: "Chips & Tostadas"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/chips-tostadas-3-1-qt44u2ir92bd1ksusxq0xe2yoa691ii1ku5uqdq07c.jpg",
    alt: "chips-tostadas-3",
    label: "Chips & Tostadas"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/chorizo-1-1-qt44u5c9tkf80eorcgxwmvdcgfscolt8l84b67ltoo.jpg",
    alt: "chorizo-1",
    label: "Chorizo"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/menudo-1-1-qt44uazaykmxy2gkfjdo1ty40r0jysfmm0181vdgnc.jpg",
    alt: "menudo-1",
    label: "Menudo"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/tacos-3-1-qt44ugmc3kunvq8diltfgsivl28r8z20mry4xj53m0.jpg",
    alt: "tacos-3",
    label: "Tacos"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/tamales-1-1-qt44ujfuo2yiuk4a251b69t9d7uuw2d7n5wldd0x3c.jpg",
    alt: "tamales-1",
    label: "Tamales"
  }];
  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    if (headingRef.current) {
      const obs = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) setHeadingVisible(true);
      }, {
        threshold: 0.2
      });
      obs.observe(headingRef.current);
      observers.push(obs);
    }
    itemRefs.current.forEach((el, i) => {
      if (!el) return;
      const obs = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setVisibleItems(prev => {
              const next = [...prev];
              next[i] = true;
              return next;
            });
          }, i * 80);
        }
      }, {
        threshold: 0.1
      });
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach(o => o.disconnect());
  }, []);
  const layoutClasses = ["col-span-2 row-span-2", "col-span-1 row-span-1", "col-span-1 row-span-1", "col-span-1 row-span-2", "col-span-1 row-span-1", "col-span-1 row-span-1", "col-span-1 row-span-1", "col-span-1 row-span-1"];
  return <section className="dark relative min-h-screen bg-background text-foreground overflow-hidden py-20 px-4 md:px-10" style={{
    backgroundImage: `url("https://sanluistortilleria.com/wp-content/uploads/2019/05/low_contrast_linen.png")`,
    backgroundRepeat: "repeat"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=Space+Mono:wght@400;700&display=swap');`}</style>

      <div className="absolute inset-0 bg-black/80 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto">

        <div ref={headingRef} className={`mb-16 transition-all duration-1000 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-6 mb-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-600 to-transparent" />
            <span className="text-amber-500 text-xs uppercase tracking-[0.4em]" style={{
            fontFamily: "'Space Mono', monospace"
          }}>
              Our Food
            </span>
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-600 to-transparent" />
          </div>
          <h2 className="text-center text-7xl md:text-9xl font-black text-transparent bg-clip-text" style={{
          fontFamily: "'Playfair Display', serif",
          backgroundImage: "linear-gradient(135deg, #f59e0b 0%, #d97706 40%, #92400e 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "-0.02em"
        }}>
            Gallery
          </h2>
          <div className="flex justify-center mt-3">
            <div className="w-24 h-1 bg-amber-600 rounded-full" />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 auto-rows-[200px] md:auto-rows-[220px]">
          {images.map((img, i) => <div key={img.alt} ref={el => {
          itemRefs.current[i] = el;
        }} className={`
                relative overflow-hidden rounded-sm cursor-pointer group
                ${layoutClasses[i]}
                ${visibleItems[i] ? "opacity-100 scale-100" : "opacity-0 scale-95"}
                transition-all duration-700
              `} onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)}>
              <div className="absolute inset-0 z-10 transition-all duration-500" style={{
            background: hoveredIndex === i ? "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0) 100%)" : "linear-gradient(to top, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 60%)"
          }} />

              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />

              <div className={`absolute inset-0 z-20 flex flex-col justify-end p-4 transition-all duration-500 ${hoveredIndex === i ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
                <span className="text-white font-bold text-sm md:text-base tracking-wider uppercase" style={{
              fontFamily: "'Space Mono', monospace"
            }}>
                  {img.label}
                </span>
                <div className="mt-1 w-8 h-0.5 bg-amber-500 rounded-full" />
              </div>

              <div className={`absolute inset-0 z-30 border-2 border-amber-500/0 rounded-sm transition-all duration-300 pointer-events-none ${hoveredIndex === i ? "border-amber-500/60" : ""}`} />

              <div className={`absolute top-3 right-3 z-30 w-6 h-6 flex items-center justify-center transition-all duration-300 ${hoveredIndex === i ? "opacity-100 scale-100" : "opacity-0 scale-75"}`}>
                <div className="w-full h-full border border-amber-400/80 rotate-45 rounded-sm" />
              </div>
            </div>)}
        </div>

        <div className="mt-12 flex justify-center">
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 rounded-full bg-amber-600" />
            <div className="w-2 h-2 rounded-full bg-amber-800" />
            <div className="w-2 h-2 rounded-full bg-amber-900" />
          </div>
        </div>
      </div>
    </section>;
}